import axiosInstance from "../../../../app/myAxiosInstance";
import axios from 'axios';

const baseApiUrl = process.env.REACT_APP_HOST + process.env.REACT_APP_BASE_API_URL;

const beatsBaseApiUrl = process.env.REACT_APP_BEATS_HOST;

const axiosInstanceBeats = axios.create({
    headers: {
        'API_KEY': process.env.REACT_APP_BEATS_API_KEY,
    }
});
/**
 * Method to get all payments
 * @param {Object} data
 */
async function getPaymentsForRefund(data) {
    try {
        const result = await axiosInstance.get(`${baseApiUrl}admin/payments/creditPayments`, { params: data });
        return result;
    } catch (err) {
        console.error('error in getPaymentsForRefund ', err);
    }

}

/**
 * Method to get all payments
 * @param {Object} data
 */
async function createRefundToCustomer(data) {
    try {
        const result = await axiosInstance.post(`${baseApiUrl}admin/refunds`, data);
        return result;
    } catch (err) {
        console.error('error in createRefundToCustomer ', err);
    }

}

async function getAllRefunds(data) {
    try {
        const result = await axiosInstance.get(`${baseApiUrl}admin/refunds`, { params: data });
        return result;
    } catch (err) {
        console.error('error in createRefundToCustomer ', err);
    }

}
async function getAllTokenPayments(data) {
    let result;
    try {
        result = await axiosInstanceBeats.post(`${beatsBaseApiUrl}/api/v1/Pms/GetTokenPaymentList`, data);

    } catch (err) {
        result = err;
        console.error('error in getAllTokenPayments ', err);
    }
    return result;
}

async function getTokenPaymentRefundHistory(data) {
    try {
        const result = await axiosInstanceBeats.post(`${beatsBaseApiUrl}/api/v1/Pms/GetprocessingFeeRefundHistory`, { OfflineListingId: data });
        return result;
    } catch (err) {
        console.error('error in getTokenPaymentRefundHistory ', err);
    }

}

export const RefundPaymentsServices = {
    getPaymentsForRefund,
    createRefundToCustomer,
    getAllRefunds,
    getAllTokenPayments,
    getTokenPaymentRefundHistory
};